import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetInvoiceApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

export interface GetInvoiceCustomApiParameterExtended   {
    invoiceNumber: string;
    expand?: ("invoiceLines" | "invoiceType=IN")[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
    invoiceType?: string ;
}

type HandlerType = ApiHandlerDiscreteParameter<{ invoiceNumber: string, invoiceType?: string }, GetInvoiceCustomApiParameterExtended, InvoiceModel>;

export const PopulateApiParameterCustom: HandlerType = props => {
    props.apiParameter = {
        invoiceNumber: props.parameter.invoiceNumber,
        expand: ["invoiceLines"],
        invoiceType: props.parameter.invoiceType,
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);